import Brain from "./brain";
import Ease from "./ease";
import VectorTools from "./vectorTools";

export default class BrainSimpleButton extends Brain {

	constructor(args) {
		super(args);
		this.onClick = args.onClick;
		this.hoverColor = args.hoverColor || false;
	}

	init(entity) {
		super.init(entity);

		let s = entity.sprite;

		s.g.onpointerdown = () => {
			this.scene.stopPropogation = true; // block global click events
			if(!s.interactive) return;
			this.onClick(this.entity);
			// this.goNormal();
		}

		s.g.onpointerover = () => {
			if(!s.interactive) return;
			this.goHovered();
		}
		
		s.g.onpointerout = () => {
			if(!s.interactive) return;
			this.goNormal();
		}
	}

	goHovered() {
		let s = this.sprite;
		if(this.initAlpha == undefined) this.initAlpha = s.alpha;
		s.slop = 1.5;
		s.alpha = 2;
		if(this.hoverColor) s.color = this.hoverColor;
	}

	goNormal() {
		let s = this.sprite;
		s.slop = 0.0;
		s.alpha = this.initAlpha || 0.5;
		s.color = s.baseColor;
	}

	disable() {
		this.goHovered();
		this.goNormal();
		this.sprite.interactive = false;
		this.sprite.g.eventMode = 'none';
		this.sprite.alpha = 0.1;
	}

	enable() {
		this.goHovered();
		this.goNormal();
		this.sprite.interactive = true;
		this.sprite.g.eventMode = 'dynamic';
	}

	updateText(string) {
		let vt = VectorTools.get();
		vt.updateTextPaths(string, this.entity);
		// this.sprite.tracers = 1;
		// this.sprite.slop = 1;
	}

}